/* Dynamic concurrent viewers count
 * Element: .dynamic-viewer-count
 * data-min / data-max: range of viewers
 * data-interval-min / data-interval-max: seconds between random refresh (default 20-50)
 * Uses localStorage to keep a stable number per session slice.
 */
(function(){
  const el = document.querySelector('.dynamic-viewer-count');
  if(!el) return;
  const d = el.dataset;
  const min = parseInt(d.min || '30',10);
  const max = parseInt(d.max || '120',10);
  const intervalMin = parseInt(d.intervalMin || '20',10);
  const intervalMax = parseInt(d.intervalMax || '50',10);
  const start = d.start ? parseInt(d.start,10) : null;
  const persistOff = (d.persist === 'false' || d.persist === '0');
  const trendUp = (d.trend === 'up');
  // Optional config for upward increments (percent based)
  const incPctMin = parseFloat(d.incPctMin || d.incrementMin || '1');
  const incPctMax = parseFloat(d.incPctMax || d.incrementMax || '3');
  const key = 'dyn_viewers';
  const ttlMinutes = 15; // refresh base after 15 min
  function load(){
    if(persistOff) return null;
    try { const raw = localStorage.getItem(key); if(raw){ const o = JSON.parse(raw); if(Date.now()-o.ts < ttlMinutes*60*1000) return o.val; } }catch(e){}
    return null;
  }
  function save(val){ if(persistOff) return; try { localStorage.setItem(key, JSON.stringify({val, ts: Date.now()})); }catch(e){} }
  function rand(){ return Math.floor(Math.random()*(max-min+1))+min; }
  let current = load();
  if(current==null){ current = (start!=null ? start : rand()); save(current); }
  el.textContent = current;
  function schedule(){
    const t = (Math.random()*(intervalMax-intervalMin)+intervalMin)*1000;
    setTimeout(()=>{
      let next = current;
      if(trendUp){
        // increase only: +1%~+3% (configurable), at least +1, capped by max
        const pct = (Math.random() * (incPctMax - incPctMin) + incPctMin) / 100;
        const inc = Math.max(1, Math.round(current * pct));
        next = Math.min(max, current + inc);
      } else {
        // small drift +/-5% within bounds
        const drift = Math.round(current * (Math.random()*0.1 - 0.05));
        next = Math.min(max, Math.max(min, current + drift));
      }
      current = next;
      el.textContent = current;
      save(current);
      schedule();
    }, t);
  }
  schedule();
})();
